<!-- 班级考勤 -->
<template>
    <div class="fuzzy-matching-box">
      <!-- <div>班级111111</div> -->
      <div class="fuzzy-matching-top">
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="时间:">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
          <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询 班级</el-button>
          <el-button type="primary" size="medium" class="query-button" @click="banjifanhui" v-if="quanxian.classId == null">返回</el-button>
            <el-col :span="5">
          </el-col >
            <el-col :span="5">
            </el-col >
            <el-col :span="5">
            </el-col >
        </el-row>
      </div>
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
           <el-table
              stripe
              :border="true"
              v-loading="loading"
              :header-cell-style="{background:'#EDF6FF',color:'#000',}"
              ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              prop="name"
              label="班级"
              >
            </el-table-column>
            <el-table-column
              prop="enter"
              label="刷卡（到校）"
              >
            </el-table-column>
           
            <el-table-column
            prop="enterNoSwipingCard"
            label='未刷卡（到校）'
            >
            </el-table-column>
            <el-table-column
            show-overflow-tooltip
              prop="leave"
              label="刷卡（离校）"
              >
            </el-table-column>
            <el-table-column
            show-overflow-tooltip
              prop="leaveNoSwipingCard"
              label="未刷卡（离校）"
              >
            </el-table-column> 
            <el-table-column
            show-overflow-tooltip
              prop="exceptionSwipingCard"
              label="异常刷卡"
              >
            </el-table-column> 
            <el-table-column
            show-overflow-tooltip
              prop="total"
              label="总数"
              >
            </el-table-column> 
          </el-table>
  
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import {classListTongji} from '@/assets/api/schoollog';

  export default {
    components: {
  
    },
    props:['ClassObj','quanxian'],
    data() {
        return {
          loading:true,
          Dform:{
            startTime:'',
            endTime:'',
            gradeId:'',
            schoolId:'',
            userId:'',
          },
          tableData: [],
          pageInfo: {
            page: 1,
            pageSize: 10,
          },
          total: 0
        };
    },
    created() {
      console.log(this.ClassObj,'我是班级');
      this.ClassTongJiClick()
    },
    mounted() {
      
    },
    methods: {
      banjifanhui () {
        this.$emit('banjifanhui')
      },
        //查询
      inquiryClick( ) {
        this.pageInfo.page = 1
        this.total = 0
        this.ClassTongJiClick()
      },
      // 列表
     ClassTongJiClick () {
        let params = {
          startTime: this.Dform.startTime,
          endTime: this.Dform.endTime,
          gradeId: this.ClassObj.id,
          // userId:JSON.parse(localStorage.getItem('user')).id,
          page: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize,
        }
        classListTongji(params).then((res)=> {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.loading = false
        }).catch((err)=> {
            console.log(err);
        })
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.ClassTongJiClick()  
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
    .fuzzy-matching-box {

      width: 100%;
      height:  92%;
      background-color: #fff;
      border-radius: 8px;
      .title-top {
          padding: 20px 20px;
      }
      .fuzzy-matching-top {
      height: 25px ;
      background-color: #fff;
      border-radius: 8px;
      .top-first-line {
        // justify-content: center 
        // justify-content: space-between
        justify-content: space-around;
        :deep() {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
    
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;          
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
          .query-button{
            margin: 0;
            }
        }
      }
     
    }
    .fuzzy-matching-bottom {
      height: calc(100% - 170px);
      overflow: auto;
      position: relative;
      padding: 0px 20px;
      padding-top: 10px;
      margin-top: 30px;
      background-color: #fff;
      border-radius: 8px;
      
      .top-first-line {
        height: 45px;
        line-height: 45px;
          :deep(.tip-button) {
            padding: 14px 14px;
            margin: 0px 3px;
          }
        .import-export-button {
          position: absolute;
          right: 20px;
          :deep(.el-button--small) {
            padding: 16px 24px;
            border: 1px solid #569CFF;
            color: #569CFF;
          }
        }
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
       .fenye {
        // float: right;
        text-align: center;
       }
        :deep() {
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            // user-select: none;
            font-size: 16px;
            color:black

          }
           .manipulate {
            color: red;
            margin-right:15px;
            // cursor: pointer;
            // user-select: none;
          }
          .confirm,.duplicate,.revise {
            color:#1677FF;
            
          }
          .el-table th.el-table__cell>.cell {
            text-align: center;
            font-size: 16px;
          }
          .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
            text-align: center;
          }
        }
        .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
  }
  </style>
  